const OppositeMsgBubble = ({ text, nextDifferent }) => (
  <div className={`opposite-msg-container ${nextDifferent ? "last" : ""}`}>
    <wb-icon name="bds/mb-star/24" />
    <div className="opposite-msg-container-text">
      {/* eslint-disable-next-line react/no-danger */}
      <wb-text dangerouslySetInnerHTML={{ __html: text }} />
    </div>
  </div>
);

export default OppositeMsgBubble;
